import { ValidatingInput, InputComponentProps } from '~/components/validating-input';
import { regexMapMeterNumber } from './utils';

export const MeterNumber = ({
  utilityId,
  validationRule,
  ...props
}: InputComponentProps & {
  utilityId?: number;
  validationRule?: {
    patterns: string[];
    helpText?: string | null;
  };
}) => {
  const validate = ({ value }) => {
    if (value.length < 1) return 'Please enter a valid meter number';

    if (validationRule) {
      const { patterns, helpText } = validationRule;
      const isValid = patterns.some(pattern => new RegExp(pattern).test(value));
      return isValid || helpText || 'Please enter a valid meter number';
    }

    const [res] = regexMapMeterNumber.filter(u => utilityId === u.utilityId);
    return res.regexExpressions.some(regex => regex.test(value)) ? true : res.errorMessage;
  };

  return (
    <ValidatingInput
      label="Meter number"
      name="meterNumber"
      validate={validate}
      {...props}
      helpContent={{
        type: 'ENROLLMENT_FIELDS',
      }}
    />
  );
};
